import axios from "axios";
import { getCookie, clearCookie } from "./cookies";

const baseURL =
  (process.env.NODE_ENV === "development"
    ? process.env.REACT_APP_DEVELOPMENT_SERVER
    : process.env.REACT_APP_PRODUCTION_SERVER) || "https://api.admin.clikkle.com";

const api = axios.create({
  baseURL,
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
  const accessToken = getCookie("accessToken");
  if (accessToken) config.headers.Authorization = `Bearer ${accessToken}`;
  return config;
});

export default api;

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    if (status === 401) {
      clearCookie("accessToken");
      clearCookie("role");
      localStorage.clear();
      if (typeof window !== "undefined") {
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);
